import * as React from "react";
import { FullScreenDialog } from "../FullScreenDialog";
import { UpdateInvoiceDetailsFormValues } from "../Forms/UpdateInvoiceDetailsForm";
import { AddInvoiceDetailsForm } from "../Forms/AddInvoiceDetailsForm";

import { DEFAULT_SERVICE_CATALOGUE_USED } from "../../lib/constants";
import { CreateInvoiceDialog } from "../Jobs/CreateInvoiceDialog";
import { useToggle } from "../../hooks/useToggle";
import { useState } from "react";
import { useInvoice } from "../../hooks/useInvoice";
export const AddInvoiceDialog: React.FC<{
  initialValues?: UpdateInvoiceDetailsFormValues;
  open: boolean;
  onClose: () => void;
  jobId: string;
  isFlorida: boolean;
  noSendCheckoutLinkDialog: boolean;
}> = ({ initialValues, open, onClose, jobId, isFlorida, noSendCheckoutLinkDialog }) => {
  const [values, setValues] = useState<UpdateInvoiceDetailsFormValues>(initialValues);
  const { createJobInvoice } = useInvoice();

  const onSubmit = async (values: UpdateInvoiceDetailsFormValues) => {
    setValues(values);
    if (noSendCheckoutLinkDialog) {
      await createJobInvoice(jobId, values);
    } else {
      toggleCreateInvoiceDialog();
    }
  };
  const [openCreateInvoiceDialog, , toggleCreateInvoiceDialog] = useToggle();
  return (
    <FullScreenDialog title={"Add Invoice"} open={open} onClose={onClose}>
      <AddInvoiceDetailsForm
        initialValues={
          initialValues
            ? initialValues
            : // seems like duplicate with [id].tsx guessing this is formik...
              {
                status: "Draft",
                contact: null,
                serviceLocation: "",
                market: "",
                technician: null,
                items: [],
                issuedDate: new Date(),
                dueDate: new Date(),
                services: [],
                discounts: [],
                promoCodes: [],
                serviceCatalogueUsed: DEFAULT_SERVICE_CATALOGUE_USED,
                serviceFollowUp: {
                  followUpNeeded: false,
                  outreachTimeline: null,
                  outreachDate: null,
                  outreachNotes: null,
                },
                proceedingWithRepairs: false,
              }
        }
        onSubmit={onSubmit}
        isFlorida={isFlorida}
      />
      <CreateInvoiceDialog
        open={openCreateInvoiceDialog}
        onClose={toggleCreateInvoiceDialog}
        jobId={jobId}
        values={values}
        isFlorida={isFlorida}
      />
    </FullScreenDialog>
  );
};
